<div id="planning_month">
    @for(week of this.weeks; track $index){
        <div class="planning_month_week">
            <div class="planning_month_week_infos" [class.today_week]="week.todayWeek" (click)="this.toggleWeek(week)">
                <div class="planning_month_week_infos_content">
                    <div class="planning_month_week_label">{{'WEEK' | translate}} {{week.numWeek}}</div>
                    <div class="planning_month_week_dates">{{week.startDate | marvDateToString}} - {{week.endDate | marvDateToString}}</div>
                </div>
                <div class="planning_month_week_infos_icon">
                    @if(week.isOpened){
                        <ion-icon name="caret-up-outline"></ion-icon>
                    }
                    @else{
                        <ion-icon name="caret-down-outline"></ion-icon>
                    }   
                </div>
            </div>
            <div class="planning_month_week_days">               
                @for(weekDay of week.days; track $index){
                    <div class="planning_month_week_day"  [class.today]="weekDay.today">
                        <div class="planning_month_week_day_infos" (click)="this.toggleDay(weekDay)">
                            <div>
                                <div class="planning_month_week_day_title">
                                    {{weekDay.day | marvDateToString: 'dddd'}}
                                    @if(weekDay.isOpened){
                                        <ion-icon name="caret-up-outline"></ion-icon>
                                    }
                                    @else{
                                        <ion-icon name="caret-down-outline"></ion-icon>
                                    }                                                                        
                                </div>
                                @if(weekDay.operations.length > 0){
                                    <div class="planning_month_week_day_operations">
                                        @for(operation of weekDay.operations; track $index){
                                            <marv-tag size="small" [color]="this.missionTypeService.getColor(operation.typeOfMission)">{{operation.name}} <span>({{operation.nbMissions}})</span></marv-tag>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="planning_month_week_items"
                            [class.open]="weekDay.isOpened"
                            >
                            @if(weekDay.planningItems.length > 0){
                               @for(planningItem of weekDay.planningItems; track $index){
                                   <app-planning-item [planningItem]="planningItem" (onSelectPlanningItem)="this.selectPlanningItem($event)"/>
                               }
                            }
                            @else {
                                <marv-message type="info">{{'MSG_NO_MISSION_PLANNING' | translate}}</marv-message>
                            }
                        </div>
                    </div>
                }                
            </div>
        </div>
    }
</div>